import { Node as ProseNode } from 'prosemirror-model'

/**
 * test whether a textual node (p, h1, h2, etc) is empty
 */
export const isEmptyTextWrap = (node: ProseNode) => {
  return node.type.groups.includes('textWrap') && node.childCount === 0
}
